import React, { Fragment } from "react"
import { QRCodeSVG } from "qrcode.react"
import { scale } from "utils"
import { useTranslation } from "react-i18next"

const PloptfcustomerQrCode = (props) => {
  const {
    templateType,
    printData,
    printerWidth
  } = props

  const {
    subdomain,
    domain,
    customDomainName,
    customerReferralCode
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const website =
    !!customDomainName
      ? `https://${customDomainName}`
      : `https://${subdomain}.${domain}`

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const qrCodeSize =
    templateType === "thermal"
      ? 200 / window.devicePixelRatio
      : 100

  return (
    <div style={styles["container"]}>
      {!!customerReferralCode
        ?
        <Fragment>
          <div style={styles["center"]}>
            {t("لطفا کد رفرال تان را با دوستان و آشنا هایتان به اشتراک بگذارید")}
          </div>
          <div style={styles["center"]}>
            {customerReferralCode}
          </div>
          <div style={styles["center"]}>
            {t("یا قفط این QR کد را اسکن کنید")}
          </div>
          <div style={styles["center"]}>
            {t("تا بتوانید امتیاز بیشتر کسب کنید.")}
          </div>

          <div style={styles["qrCenter"]}>
            <QRCodeSVG
              size={qrCodeSize}
              value={`${website}?referralCode=${customerReferralCode}`}
            />
          </div>
        </Fragment>
        :
        <div style={styles["qrCenter"]}>
          <QRCodeSVG
            size={qrCodeSize}
            value={website}
          />
        </div>
      }

      <div style={styles["text3"]}>
        {`${website}${customerReferralCode ? `?referralByCode=${customerReferralCode}` : ""}`}
      </div>
    </div>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  text3: {
    textAlign: "center",
    marginTop: scale("10px")
  },

  center: {
    textAlign: "center",
    marginTop: scale("8px")
  },

  qrCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: scale("8px")
  }
})

const stylesOthers = () => ({
  container: {
    marginRight: "8px",
    paddingTop: "4px",
    fontSize: "11px"
  },

  text3: {
    textAlign: "center",
    marginTop: "4px"
  },

  center: {
    textAlign: "center",
    marginTop: "4px"
  },

  qrCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
})

export default PloptfcustomerQrCode